<template>
    <div class="relative emoji">
        <div v-for="(item, index) in imgs" :key="index">
            <div class="absolute thumbnail" :id="'img_'+index">
                <img class="img-responsive" v-parallax="0.2" :src="item" :alt="item" :style="$route.path == '/seja-um-franqueado' ? 'display:none;' : 'display:block' " >
            </div>
        </div>    
        <div class="absolute thumbnail" id="img_7">
            <img class="img-responsive" v-parallax="0.2" src="@/assets/home/emoji/Imagem_7.png" alt="Imagem_7.png" :style="$route.path == '/seja-um-franqueado' ? 'display:block;' : 'display:none' " >
        </div>   
    </div>
</template>

<style scoped>
    #img_0,
    #img_1,
    #img_2,
    #img_3,
    #img_4,
    #img_5
    {
        z-index: 500
    }
    #img_0{
        -webkit-transform: rotateZ(-30deg);
                transform: rotateZ(-30deg);
        top: 500px;
    }
    #img_0 img{
        width: 80%
   }
    #img_1{
        top: 650px;
        right: 10px;
        -webkit-transform: rotateZ(-25deg);
                transform: rotateZ(-25deg);
    }
    #img_2{
        top: 1100px;
        -webkit-transform: rotateZ(-32deg);
                transform: rotateZ(-32deg);
        left: 10px;
    }
    #img_3{
        top: 1500px;
        right: -175px;
        -webkit-transform: rotateZ(29deg);
                transform: rotateZ(29deg);
    }
    #img_3 img{
        width: 80%
   }
    
    #img_4{
        top: 1700px;
        -webkit-transform: rotateZ(30deg);
                transform: rotateZ(30deg);
    }
    #img_5{
        /* top: 750px;
        right: 10px; */
        top: 811px;
        right: -27px;
        -webkit-transform: rotateZ(34deg);
                transform: rotateZ(34deg);
    }
    #img_6{
        top: 850px;
        right: 10px;
    }

    #img_7{
        z-index: 1;
        top: 500px;
        left: 200px;
    }
    #img_7 img{
        width: 200px;
    }    

    @media only screen and (max-width: 768px){
        #img_0, #img_3{
            width: 100px
        }
        #img_3{
            top: 1500px;
            right: -30px;
            -webkit-transform: rotateZ(-30deg);
                    transform: rotateZ(-30deg);
        }
        .thumbnail img{
            width: 60px;
        }

        #img_7{
            display: none;
        }

          
    }

    @media only screen and (max-width: 420px){
        #img_7{
            z-index: 1;
            top: 400px;
            left: 0;
        }
        #img_7 img{
            width: 100px;
        }
    }    
    
</style>

<script>

import $ from 'jquery'

export default {
    data() {
        return {
            imgs:[
                require('@/assets/home/emoji/Imagem_1.png'),
                require('@/assets/home/emoji/Imagem_2.png'),
                require('@/assets/home/emoji/Imagem_3.png'),
                require('@/assets/home/emoji/Imagem_4.png'),
                require('@/assets/home/emoji/Imagem_5.png'),
                require('@/assets/home/emoji/Imagem_6.png'),
            ]
        }
    },
    component: {
    },
    mounted() {
        if($(window).width()<=768 && this.$route.path != '/'){
            $(".emoji").css({"display":"none"})
        }
    },
    methods: {
    },
}
</script>